<script>
export default {
  name: "HeaderBar",
  props: {
    /**
     * PROP: title
     * The title text to display in the header bar.
     **/
    title: {
      type: String,
      required: true
    },
    /**
     * PROP: buttons
     * An array of button objects to display. Each button object should have:
     * - label: String (text displayed on the button)
     * - onClick: Function (click event handler for the button)
     **/
    buttons: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<template>
  <div class="bg-white border border-gray-300 rounded-xl mt-2 p-4 px-6 flex justify-between items-center">
    <p class="pb-0 font-bold">
      {{ title }}
    </p>
    <div class="flex flex-row text-sm">
      <!-- Use slot if provided, otherwise render buttons from props -->
      <slot name="buttons">
        <template v-if="buttons && buttons.length">
          <button
            v-for="(button, index) in buttons"
            :key="index"
            :class="['btn-outline', (index < buttons.length - 1 ? 'mr-2' : '')]"
            @click="button.onClick"
          >
            {{ button.label }}
          </button>
        </template>
      </slot>
    </div>
  </div>
</template>

<style lang="scss">

</style>
